import React from 'react'
import { Tooltip, CircleMarker } from 'react-leaflet'
import L from 'leaflet'

import { MarkerOptions } from './mapTypes'

interface Props {
  content: string
  styles: MarkerOptions
  radius: number
  center: [number, number]
  pane?: string
}

const Marker = (props: Props) => {
  return (
    <CircleMarker
      center={props.center}
      radius={props.radius}
      pathOptions={{ fill: true, fillOpacity: 1, ...props.styles }}
      pane={props.pane}
    >
      <Tooltip
        pane={'popupPane'}
        className={'tooltip'}
        direction={'bottom'}
        offset={L.point(0, 15)}
      >
        {props.content}
      </Tooltip>
    </CircleMarker>
  )
}

export default React.memo(Marker)
